import React, { useState} from "react";
import logo from './logo.jpg';
import './App.css';
import General from './general.js';
import Footer from './Footer.js';
import SelectorPais, { ID_SELECTOR_PAIS_NAVBAR } from './SelectorPais.js';
import SelectorIdioma from './SelectorIdioma.js';
import I18nRuntime from './i18n/I18nRuntime.js';
import {Navbar, NavbarToggler} from 'reactstrap';
import {FaUserAlt} from 'react-icons/fa';
import {FaAddressCard} from 'react-icons/fa';
import {FaMapMarker} from 'react-icons/fa';
import {
  Card,
  CardBody,
  CardImg,
  CardTitle,
  CardText,
  CardHeader,
  CardFooter,
} from 'reactstrap';
function App() {
  const [versioApp, setVersioApp] = useState("");
   const handleDatosVersion = (datos) => {
    setVersioApp(datos);
  };
 sessionStorage.clear();
  return (<div >
    <div >
      <header >

        <Navbar className="app-navbar" expand="sm" style={{ justifyContent: 'space-between' }}>

          <img height="145px" src={logo} width="auto" alt="logo"/>

          <div className="app-navbar__selectores">
            <SelectorPais id={ID_SELECTOR_PAIS_NAVBAR} className="app-navbar__pais" />
            <SelectorIdioma />
          </div>

        </Navbar>

        <div className="app-header-accent" />
      </header>


        <I18nRuntime />
        <General onSetVersion={handleDatosVersion}/>

<br></br>
  <Footer versionApp={versioApp} />

    </div>
  </div>);
}

export default App;
